import { render, staticRenderFns } from "./transfer.vue?vue&type=template&id=5958d2a6&"
import script from "./transfer.vue?vue&type=script&lang=js&"
export * from "./transfer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("F:\\haohao\\QW\\allnet_crm\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5958d2a6')) {
      api.createRecord('5958d2a6', component.options)
    } else {
      api.reload('5958d2a6', component.options)
    }
    module.hot.accept("./transfer.vue?vue&type=template&id=5958d2a6&", function () {
      api.rerender('5958d2a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/components/transfer.vue"
export default component.exports